<template>
  <div v-show="!loading">
    <div class="mdl-grid">
      <div class="mdl-cell mdl-cell--4-col">
        <div class="mdl-card fill mdl-shadow--2dp ga-tall-card">
          <div class="mdl-tabs mdl-js-tabs">
            <div class="mdl-tabs__tab-bar ga-form-title">
              <a href="#detailsTab1" class="mdl-tabs__tab is-active">{{'newDelayed.label.details' | label}}</a>
              <a href="#faq" class="mdl-tabs__tab">{{'newDelayed.label.faq' | label}}</a>
            </div>
            <div class="mdl-tabs__panel is-active" id="detailsTab1">
              <delayed-details :tab="tab"></delayed-details>
            </div>
            <div class="mdl-tabs__panel" id="faq">
              <faq service="delayed"></faq>
            </div>
          </div>
        </div>
      </div>
      <div class="mdl-cell mdl-cell--8-col">
        <message-form :model="message"></message-form>
      </div>
    </div>
  </div>
</template>

<script>
var api = require('api')
var getters = require('common/store/getters')
var actions = require('common/store/actions')
// var payment = require('api/Payment')
module.exports = {
  ready: function () {
    // user not active yet
    if (this.user.status === 'PENDING') {
      this.$router.replace('/app/userpending')
      return
    }
    if (this.user.subscription && this.user.subscription.status === 'Pending') {
      api.User.createPaymentUrl({id: this.user.id}).then((response) => {
        this.$router.replace('/app/payment/' + response.data.token)
      }).catch((err) => {
        this.$dispatch('show-error', err.data)
      })
      return
    }

    var self = this
    var id = this.$route.params.id

    if (id !== 'new') {
      this.messageId = id
      api.Message.get({
        id: this.messageId
      })
        .then(function (resp) {
          self.message = resp.data
        }, this.onError)
    }

    api.Subscription.get()
      .then(
        function (res) {
          self.subscription = res.data.subscription
          self.loading = false
        },
        function () {
          self.subscription.isActive = false
          self.loading = false
        })
  },
  vuex: {
    getters: getters,
    actions: actions
  },
  components: {
    messageForm: require('c/forms/MessageForm'),
    'delayed-details': require('c/segments/DelayedDetails'),
    'faq': require('c/segments/FAQ')
  },
  events: {
    'message-valid': function (message) {
      this.$dispatch('loading', true)
      if (this.messageId) {
        api.Message.update({id: this.messageId}, message).then(this.onSuccess, this.onError)
      } else {
        message['userId'] = this.user.id
        api.Message.save(message).then(this.onSuccess, this.onError)
      }
    }
  },
  methods: {
    onSuccess: function (resp) {
      let self = this
      self.reloadUser().then(function () {
        self.$dispatch('show-success', resp.data)
        self.$dispatch('loading', false)
        self.$router.go('/app/managed')
      })
    },
    onError: function (err) {
      this.$dispatch('show-error', err.data)
    }
  },
  data: function () {
    return {
      subscription: {
        isActive: true
      },
      loading: true,
      messageId: '',
      message: {
        recipients: '',
        subject: '',
        messageBody: '',
        attachments: []
      },
      initDate: '',
      tab: '3'
    }
  }
}
</script>



// WEBPACK FOOTER //
// Message.vue?5c4c7229